import baseApi from 'store/slices/api/baseApi'

const filesApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        uploadImage: build.mutation({
            query: ({body}) => ({
                url: 'uploads/image',
                method: 'POST',
                body,
            }),
        }),
        uploadMedia: build.mutation({
            query: ({body}) => ({
                url: `uploads/media`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['Dance'],
        }),
    }),
})

export default filesApi

export const {useUploadImageMutation, useUploadMediaMutation} = filesApi
